import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColorCategoryItem } from "../../interfaces/Config";
import {
  // Color,
  // Volume,
  VolumeColorTransferNormalized,
} from "../../interfaces/HairTransfer";
import { fetchConfig } from "../../services/config";
import { fetchUploadSelfie } from "../../services/selfie";
import {
  getColorByBrands,
  getColorByCategories,
} from "../../utils/processConfig";

// Type definitions
export const initial = {
  colors: undefined,
  volumes: undefined,
  brands: undefined,
  transfers: undefined,
  storedPhoto: "",
  showSmallLoader: true,
  selectedVolume: undefined,
  selectedColor: undefined,
  appliedImage: "",
  config: undefined,
  isError: false,
  selectedSubColor: undefined,
  loader: false,
  genomeIds: undefined,
  isNecessaryChange: false,
};
interface ICurrentCustomer {
  colors?: ColorCategoryItem[];
  volumes: any;
  brands: any;
  transfers: VolumeColorTransferNormalized[];
  storedPhoto: string;
  showSmallLoader: boolean;
  selectedVolume: any;
  selectedColor: any;
  appliedImage: string;
  config: any;
  isError: boolean;
  selectedSubColor: any;
  loader: boolean;
  genomeIds: any;
  isNecessaryChange: boolean;
}

// Define a type for your state
type State = ICurrentCustomer | typeof initial;

const initialState: State = initial;
interface VolumeColorTransferNormalizedState {
  transfers?: VolumeColorTransferNormalized[];
}

export const volumeSlice = createSlice({
  name: "volume",
  initialState: initialState as State,
  reducers: {
    setColors: (state, action) => {
      state.colors = action.payload;
      state.selectedColor = undefined;
    },
    setVolumes: (state, action) => {
      state.volumes = action.payload;
      state.selectedVolume = undefined;
    },
    resetError: (state) => {
      state.isError = false;
    },
    setTransfers: (
      state: VolumeColorTransferNormalizedState,
      action: PayloadAction<VolumeColorTransferNormalized[] | undefined>
    ) => {
      if (!state.transfers) state.transfers = action.payload;
      else {
        const newTransfers = action?.payload?.filter((transfer) => {
          return !state.transfers?.some(
            (existingTransfer) =>
              existingTransfer.color === transfer.color &&
              existingTransfer.volume === transfer.volume
          );
        });
        if (newTransfers)
          state.transfers = state.transfers.concat(newTransfers);
      }
    },
    deleteTransfers: (state, action) => {
      state.transfers = action.payload;
    },
    setStoredPhoto: (state, action) => {
      state.storedPhoto = action.payload;
    },
    setShowSmallLoader: (state, action) => {
      state.showSmallLoader = action.payload;
    },
    setLoader: (state, action) => {
      state.loader = action.payload;
    },
    setSelectedColor: (state, action) => {
      state.selectedColor = action.payload;
      state.isNecessaryChange = true;
    },
    setSelectedSubColor: (state, action) => {
      state.selectedSubColor = action.payload;
      state.isNecessaryChange = true;
    },
    setGenomeIds: (state, action) => {
      state.genomeIds = action.payload;
    },
    setSelectedVolume: (state, action) => {
      state.selectedVolume = action.payload;
      state.isNecessaryChange = true;
    },
    setAppliedImage: (state, action) => {
      state.appliedImage = action.payload;
    },
    setIsNecessaryChange: (state, action) => {
      state.isNecessaryChange = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(
      fetchUploadSelfie.pending,
      (state, action: PayloadAction<any | undefined>) => {
        state.transfers = undefined;
      }
    ),
      builder.addCase(fetchConfig.fulfilled, (state, action) => {
        state.config = action.payload?.data;
        state.volumes = action.payload?.data?.volumes;
        state.colors = getColorByCategories(action.payload?.data);
        state.brands = getColorByBrands(action.payload?.data);
      });
  },
});

export const {
  setVolumes,
  setColors,
  setTransfers,
  setStoredPhoto,
  setShowSmallLoader,
  setSelectedColor,
  setSelectedVolume,
  setAppliedImage,
  resetError,
  setSelectedSubColor,
  setLoader,
  setGenomeIds,
  deleteTransfers,
  setIsNecessaryChange,
} = volumeSlice.actions;

export default volumeSlice.reducer;
